import loadable from '@loadable/component'


const DashboardDeploymentConfig = {
    list: loadable(() => import("./DashboardDeploymentList")),
    edit: loadable(() => import("./DashboardDeploymentEdit")),
    create: loadable(() => import("./DashboardDeploymentCreate"))
};

export default DashboardDeploymentConfig